export default {"src":"/_next/static/media/SpinalInfectionsandTumors.1551df05.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};